import { WarmthCheckAddressFinderRendering } from '@sitecore/types/WarmthCheckAddressFinder';

export const mapErrorToMessage = (
  status: number,
  textualData: WarmthCheckAddressFinderRendering['fields'],
): { title: string; content: string } | undefined => {
  switch (status) {
    case 400:
      return {
        title: textualData?.notification?.noWarmthNotification?.value?.title || '',
        content: textualData?.notification?.noWarmthNotification?.value?.content || '',
      };
    case 404:
      return {
        title: textualData?.notification?.notFoundErrorNotification?.value?.title || '',
        content: textualData?.notification?.notFoundErrorNotification?.value?.content || '',
      };
    default:
      return {
        title: textualData?.notification?.serverErrorNotification?.value?.title || '',
        content: textualData?.notification?.serverErrorNotification?.value?.content || '',
      };
  }
};
